import React, { useState, useRef, useContext, useEffect } from "react";
import { useSelector } from "react-redux";

// context
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import { DispatchContext as HomeDispatchContext } from "bodycodi/cmap/app/components/cmap2010/home";

// components
import AddComunityHeader from "./Header";
import {
  AddCommunityMembers,
  CommunityTitleInputField,
  RenderVideos,
  RenderVideoLinks,
  RenderImages,
  BottomButtons,
} from "../common";

// redux
import { RootState } from "bodycodi/cmap/app/redux/store";

// types
import { AddCommunityProps } from "./types";

// utils
import { isEmpty } from "bodycodi/cmap/app/js/common";
import { api } from "bodycodi/cmap/app/js/api";

const AddCommunity = ({ handleClose }: AddCommunityProps) => {
  const { seqPartner, seqPartnerBranch, seqPartnerCoach } = useSelector(
    (state: RootState) => state.partner
  );
  const { state: commonState } = useContext(StateContext);
  const { dispatch } = useContext(DispatchContext);
  const { dispatch: homeDispatch } = useContext(HomeDispatchContext);
  const [loading, setLoading] = useState<boolean>(false);
  const [openAddLink, setOpenAddLink] = useState<boolean>(false);
  const imageFileRef = useRef<any>(null);
  const [textAreaContent, setTextAreaContent] = useState<string>("");
  const [chosenMembers, setChosenMembers] = useState<any>({});
  const [title, setTitle] = useState<string>("");
  const [videoLinks, setVideoLinks] = useState<any>([]);
  const [videoFiles, setVideoFiles] = useState<any>([]);
  const [imageFiles, setImageFiles] = useState<any>([]);
  const [imageToEdit, setImageToEdit] = useState<any>({});
  const [linkToEdit, setLinkToEdit] = useState<string>("");

  const registerNewCommunity = async () => {
    dispatch({ type: "LOADING_START" });
    setLoading(true);

    const requestBody: any = {};
    const videoData: any = [];
    const imageData: any = [];
    const linkData: any = [];
    const memberVoList: any = [];

    // video files
    if (!isEmpty(videoFiles)) {
      videoFiles.forEach((item: any) => {
        const newVideoData = {
          fileId: item.fileId,
        };
        videoData.push(newVideoData);
      });
    }

    // video links
    if (!isEmpty(videoLinks)) {
      videoLinks.forEach((item: any) => {
        const newVideoLink = {
          fileId: item.fileId,
        };
        linkData.push(newVideoLink);
      });
    }

    // images
    if (!isEmpty(imageFiles)) {
      imageFiles.forEach((item: any) => {
        const newImage = {
          fileId: item.data.fileId,
        };
        imageData.push(newImage);
      });
    }

    // members
    if (!isEmpty(chosenMembers)) {
      for (const item in chosenMembers) {
        const member = chosenMembers[item];
        memberVoList.push(member);
      }
    }

    for (let i = 0; i < chosenMembers.length; i++) {
      linkData.fileUrl = chosenMembers[i];
    }

    // seqData
    requestBody.files = [...videoData, ...linkData, ...imageData];
    requestBody.title = title;
    requestBody.content = textAreaContent;
    requestBody.members = memberVoList;
    requestBody.seqPartner = seqPartner;
    requestBody.seqPartnerBranch = seqPartnerBranch;
    requestBody.seqPartnerCoach = seqPartnerCoach;

    // request
    await api.post("/community/upload", { ...requestBody }).then((res) => {
      dispatch({ type: "UPDATE", data: { toast1: true, toastText: "새 글이 등록되었습니다." } });
      homeDispatch({ type: "UPDATE_COMUNITY" });
      dispatch({ type: "LOADING_END" });
      setLoading(false);
      handleClose();
    });
  };

  useEffect(() => {
    // get the seqMember when coming from 회원정보
    if (!isEmpty(commonState.addComunitySeqmember)) {
      chosenMembers[commonState.addComunitySeqmember.seqMember] = commonState.addComunitySeqmember;
    }
    setChosenMembers({ ...chosenMembers });
  }, []);

  return (
    <>
      <AddComunityHeader
        handleClose={handleClose}
        clickReg={registerNewCommunity}
        disabled={loading || isEmpty(chosenMembers) || textAreaContent.length < 1 || isEmpty(title)}
      />

      <div className="popup-body add-comunity-pop">
        <AddCommunityMembers chosenMembers={chosenMembers} setChosenMembers={setChosenMembers} />
        <CommunityTitleInputField value={title} onChange={setTitle} />

        <div
          className="add-comunity-decs"
          onClick={() => {
            setOpenAddLink(false);
            setLinkToEdit("");
          }}
        >
          {videoFiles.length > 0 && (
            <RenderVideos videoFiles={videoFiles} setVideoFiles={setVideoFiles} />
          )}
          {videoLinks.length > 0 && (
            <RenderVideoLinks
              videoLinks={videoLinks}
              setVideoLinks={setVideoLinks}
              setLinkToEdit={setLinkToEdit}
              setOpenAddLink={setOpenAddLink}
            />
          )}
          {imageFiles.length > 0 && (
            <RenderImages
              imageFiles={imageFiles}
              setImageFiles={setImageFiles}
              setImageToEdit={setImageToEdit}
            />
          )}
          <textarea
            placeholder="내용 입력 (필수)"
            value={textAreaContent}
            onChange={(e) => setTextAreaContent(e.target.value)}
            maxLength={3000}
          />
        </div>

        <BottomButtons
          imageFiles={imageFiles}
          videoFiles={videoFiles}
          imageToEdit={imageToEdit}
          setImageFiles={setImageFiles}
          setVideoFiles={setVideoFiles}
          setImageToEdit={setImageToEdit}
          imageFileRef={imageFileRef}
          openAddLink={openAddLink}
          setOpenAddLink={setOpenAddLink}
          videoLinks={videoLinks}
          setVideoLinks={setVideoLinks}
          linkToEdit={linkToEdit}
          setLinkToEdit={setLinkToEdit}
        />
      </div>
    </>
  );
};

export default AddCommunity;
